import axios from "axios";
import React, { createContext, useContext, useState, useEffect } from "react";

const DashboardContext = createContext();

const baseURL = process.env.REACT_APP_API_BASE_URL;



export const DashboardProvider = ({ children }) => {
  const [packages, setPackage] = useState([]);
  const [loading, setLoading] = useState(true);
  const [contactDetails, setContactDetails] = useState();
  const [getDashboardForWebsite, setDashboardForWebsite] = useState([])
  const authToken = localStorage.getItem("accessToken");
  const userId = localStorage.getItem("authToken");
  const [allIncidentReports,setAllIncidentReports] = useState([])
const [allTrucks,setTrucks]=useState([])
  const [userProfile, setUserProfile] = useState([]);

  const fetchPackageData = async () => {


    console.log('c', baseURL)
    try {
      setLoading(true);

      const response = await axios.get(`${baseURL}/static/getPackage`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      setPackage(response?.data?.data);
    } catch (error) {
      // console.error("Error fetching dashboard data:", error?.message || error);
    } finally {
      setLoading(false);
    }
  };



  const FetchProfile = async () => {


    console.log('c', baseURL)
    try {
      setLoading(true);

      const response = await axios.get(`${baseURL}/user/getProfile`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      setUserProfile(response?.data?.data);
    } catch (error) {
      // console.error("Error fetching dashboard data:", error?.message || error);
    } finally {
      setLoading(false);
    }
  };




  const fetchContactDetails = async () => {


    console.log('c', baseURL)
    try {
      setLoading(true);

      const response = await axios.get(`${baseURL}/static/viewContactDetails`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      setContactDetails(response?.data?.data);
    } catch (error) {
      // console.error("Error fetching dashboard data:", error?.message || error);
    } finally {
      setLoading(false);
    }
  };



  const PaymentForPackage = async (id,body) => {

    try {
      setLoading(true);
      const res = await axios.post(
        `${baseURL}/user/checkOutPackageById/${id}`,
       body,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      return { success: true, data: res.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message,
      };
    } finally {
      setLoading(false);
    }
  };



  const cancelPackageMemberShip = async (id) => {

    try {
      setLoading(true);
      const res = await axios.post(
        `${baseURL}/user/cancelPackageMemberShip`,
        {},
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      return { success: true, data: res.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message,
      };
    } finally {
      setLoading(false);
    }
  };

  const CancelForAiPackage = async (id) => {
    try {
      setLoading(true);
      const res = await axios.post(
        `${baseURL}/user/cancelAiPackageMemberShip`,
        {},
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      return { success: true, data: res.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message,
      };
    } finally {
      setLoading(false);
    }
  };



  const sendQuery = async () => {


    // console.log('c',baseURL)
    try {
      setLoading(true);

      const response = await axios.post(`${baseURL}user/sendInquire`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      return response;
    } catch (error) {
      // console.error("Error fetching dashboard data:", error?.message || error);
    } finally {
      setLoading(false);
    }
  };

  const FetchDashboardForWebsite = async () => {


    // console.log('c',baseURL)
    try {
      setLoading(true);

      const response = await axios.get(`${baseURL}user/getDashboardForWebsite`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setDashboardForWebsite(response.data)
      return response;

    } catch (error) {
      // console.error("Error fetching dashboard data:", error?.message || error);
    } finally {
      setLoading(false);
    }
  };


const uploadDocumentDriver = async (id, data) => {
  try {
    setLoading(true);

    const response = await axios.put(
      `${baseURL}/admin/updateDocumentWithBody/${id}`,
      data, // ✅ request body
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );

    return response.data; // ✅ usually you want .data
  } catch (error) {
    console.error("Error uploading document:", error);
    throw error; // ✅ rethrow to handle it outside if needed
  } finally {
    setLoading(false);
  }
};


  const FetchAllIncidentReports = async () => {


    // console.log('c',baseURL)
    try {
      setLoading(true);

      const response = await axios.get(`${baseURL}/Admin/getAllIncidentReports`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setAllIncidentReports(response.data)
      return response;

    } catch (error) {
      // console.error("Error fetching dashboard data:", error?.message || error);
    } finally {
      setLoading(false);
    }
  };


    const FetchAllITrucks = async () => {


    // console.log('c',baseURL)
    try {
      setLoading(true);

      const response = await axios.get(`${baseURL}/Company/getAllTruck`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setTrucks(response?.data?.data)
      return response;

    } catch (error) {
      // console.error("Error fetching dashboard data:", error?.message || error);
    } finally {
      setLoading(false);
    }
  };

  const updateInvoices = async (invoiceId, data) => {
    try {
      setLoading(true);
      const response = await axios.put(`${baseURL}/user/updateInvoices/${invoiceId}`, data, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating invoice:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardContext.Provider
      value={{
        FetchAllITrucks,allTrucks,
        FetchDashboardForWebsite, getDashboardForWebsite,uploadDocumentDriver,FetchAllIncidentReports,allIncidentReports,
        packages, FetchProfile, userProfile, cancelPackageMemberShip, CancelForAiPackage,
        fetchPackageData,
        loading,
        sendQuery, contactDetails, PaymentForPackage,
        fetchContactDetails,
        updateInvoices
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

// Hook for easy use
export const useDashboard = () => useContext(DashboardContext);
